module.exports = __webpack_public_path__ + "static/media/components.72295ef6.png";